import { Box, Button, Dialog, Portal, Stack } from '@chakra-ui/react'
import { Field, Formik } from 'formik'
import { useEffect } from 'react'
import { Form, InputForm } from 'uikit'
import * as Yup from 'yup'
import { useLunaSettingsFetch } from './services/useLunaSettingsFetch'
import { useLunaSettingsUpdate } from './services/useLunaSettingsUpdate'

const formSchema = Yup.object({
  failedLivenessAttemptsLimit: Yup.number()
    .integer('invalid decimal')
    .min(0, 'Min')
    .required('Заполните поле'),
  similarityMinimumRate: Yup.number()
    .integer('invalid decimal')
    .max(100, 'Max')
    .min(0, 'Min')
    .required('Заполните поле'),
  similarityRate: Yup.number()
    .integer('invalid decimal')
    .max(100, 'Max')
    .min(0, 'Min')
    .required('Заполните поле'),
})

export const LunaSettings = ({ isOpen, onClose }) => {
  const { refetch: getLunaSettings, isPending: isLoadingFetch, data } = useLunaSettingsFetch()
  const { mutate: updateLunaSettings, isPending: isLoadingUpdate } = useLunaSettingsUpdate()

  useEffect(() => {
    if (isOpen) {
      getLunaSettings()
    }
  }, [isOpen])

  const handleForm = (values) => {
    const dataRequest = {
      ...data,
      failedLivenessAttemptsLimit: Number(values.failedLivenessAttemptsLimit),
      similarityMinimumRate: Number(values.similarityMinimumRate) / 100,
      similarityRate: Number(values.similarityRate) / 100,
    }
    updateLunaSettings(dataRequest, {
      onSuccess: () => {
        onClose()
      }
    })
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Настройка ручной идентификации</Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>
            <Dialog.Body>
              <Formik
                enableReinitialize
                validationSchema={formSchema}
                initialValues={{
                  failedLivenessAttemptsLimit: String(data?.failedLivenessAttemptsLimit) ?? 0,
                  similarityMinimumRate: String(data?.similarityMinimumRate * 100) ?? 0,
                  similarityRate: String(data?.similarityRate * 100) ?? '0',
                }}
                onSubmit={handleForm}
              >
                {(props) => (
                  <Form onSubmit={props.handleSubmit}>
                    <Stack gap={4}>
                      <Field
                        name="failedLivenessAttemptsLimit"
                        label="Лимит попыток идентификаций пользователя"
                        component={InputForm}
                        placeholder="0"
                      />
                      <Field
                        name="similarityMinimumRate"
                        label="Минимальный % совпадения"
                        component={InputForm}
                        placeholder="0"
                        endAddon="%"
                      />
                      <Field
                        name="similarityRate"
                        label="Максимальный % совпадения"
                        component={InputForm}
                        placeholder="0"
                        endAddon="%"
                      />
                    </Stack>
                    <Box pt="30px">
                      <Button
                        type="submit"
                        colorPalette="orange"
                        loading={isLoadingUpdate || isLoadingFetch}
                      >
                        Сохранить
                      </Button>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
